import React, { lazy } from 'react';
import { useFadeIn } from '../hooks/useFadeIn';
import { CTAButton } from './CTAButton';
export function BonusSection() {
  const fadeIn = useFadeIn();
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const bonuses = [{
    id: 1,
    title: 'Kit SOS Calma en 10 Minutos',
    desc: 'Protocolo de emergencia emocional paso a paso para crisis de ira, ansiedad o bloqueo. Para usar en el momento exacto.',
    image: 'https://cdn.magicpatterns.com/uploads/gPATjXLJZmmpkuAgNJjJVB/bono_1_(3).webp',
    price: '$27'
  }, {
    id: 2,
    title: 'Autoestima a Prueba de Redes',
    desc: 'Workbook práctico anti-comparación. Ejercicios concretos para construir identidad que no depende de ningún like.',
    image: 'https://cdn.magicpatterns.com/uploads/2Uc2cfokx7cfYxMMecKSpK/bono_2_(3).webp',
    price: '$27'
  }, {
    id: 3,
    title: 'Conversaciones Difíciles Sin Pelear',
    desc: 'Scripts listos para las 10 situaciones más tensas entre padres/docentes y adolescentes. Las palabras exactas.',
    image: 'https://cdn.magicpatterns.com/uploads/dWwwE9K4a2ySfJZ4X3uyHS/bono_3_(3).webp',
    price: '$37'
  }, {
    id: 4,
    title: 'Semana Calma',
    desc: 'Planner semanal con checklists de mañana, tarde y noche para bajar la ansiedad y los conflictos. Imprimible y rellenable.',
    image: 'https://cdn.magicpatterns.com/uploads/9QB8YR3S4keAgWL6gqcCs6/bono_4_(3).webp',
    price: '$17'
  }, {
    id: 5,
    title: 'Límites Sin Culpa',
    desc: 'Guía práctica para decir NO con respeto y seguridad. Scripts, tarjetas recortables y fórmulas para cada tipo de presión.',
    image: 'https://cdn.magicpatterns.com/uploads/7Yq8vRLSbtsBx3KjLu5mkS/bono_5_(3).webp',
    price: '$17'
  }, {
    id: 6,
    title: 'Un Año de Progreso Emocional',
    desc: 'Tracker completo de 12 meses para medir avances reales en regulación, autoestima, relaciones y propósito.',
    image: 'https://cdn.magicpatterns.com/uploads/411n75beDmj1aWfMX3aKRK/bono_6_(3).webp',
    price: '$47'
  }];
  return <section className="py-12 md:py-16 px-4 bg-gray-900 text-white border-y-8 border-yellow-400" data-id="element-15">
      <div className="max-w-3xl mx-auto" data-id="element-16">
        <div ref={fadeIn.ref} className={fadeIn.className} data-id="element-17">
          <div className="text-center mb-8 md:mb-12" data-id="element-18">
            <h2 className="text-2xl md:text-5xl font-black text-yellow-400 mb-3 md:mb-4" data-id="element-19">
              🎁 6 BONOS DE ACCIÓN — SIEMPRE INCLUIDOS
            </h2>
            <p className="text-lg md:text-2xl font-bold text-white" data-id="element-20">
              Valor total bonos $172 → GRATIS con tu MegaPack
            </p>
          </div>

          <div className="space-y-6 md:space-y-8 mb-10 md:mb-12" data-id="element-21">
            {bonuses.map(bonus => <div key={bonus.id} className="bg-white text-gray-900 rounded-2xl p-4 md:p-6 shadow-lg md:shadow-2xl relative border-2 md:border-4 border-yellow-400 overflow-hidden" style={{
            contentVisibility: 'auto',
            containIntrinsicSize: '0 400px'
          }} data-id="element-22">
                <div className="absolute top-3 md:top-4 right-[-35px] bg-red-600 text-white font-black py-1 px-10 transform rotate-45 shadow-md text-xs md:text-base" data-id="element-23">
                  GRATIS HOY
                </div>

                <div className="flex flex-col md:flex-row items-center gap-4 md:gap-6" data-id="element-24">
                  <button onClick={scrollToPricing} className="w-full md:w-1/3 flex-shrink-0 cursor-pointer md:hover:scale-105 md:transition-transform" data-id="element-25">
                    <img src={bonus.image} alt={`Bono ${bonus.id}`} className="w-[180px] h-[180px] md:w-[250px] md:h-[250px] object-contain mx-auto" loading="lazy" decoding="async" width={180} height={180} data-id="element-26" />
                  </button>

                  <div className="text-center md:text-left flex-1" data-id="element-27">
                    <div className="inline-block bg-yellow-400 text-black font-black px-3 py-1 rounded-md mb-2 md:mb-3 text-xs md:text-sm uppercase tracking-wider" data-id="element-28">
                      🎁 Bono {bonus.id}
                    </div>
                    <h3 className="text-xl md:text-2xl font-black text-gray-900 mb-2 md:mb-3 leading-tight" data-id="element-29">
                      {bonus.title}
                    </h3>
                    <p className="text-base md:text-lg text-gray-600 mb-3 md:mb-4 font-medium" data-id="element-30">
                      {bonus.desc}
                    </p>
                    <p className="inline-block bg-gray-100 px-3 md:px-4 py-1.5 md:py-2 rounded-lg text-xs md:text-sm font-bold text-gray-500 border border-gray-200" data-id="element-31">
                      Valor estimado:{' '}
                      <span className="line-through text-red-500" data-id="element-32">
                        {bonus.price} USD
                      </span>{' '}
                      <span className="text-green-600 ml-1" data-id="element-33">¡GRATIS!</span>
                    </p>
                  </div>
                </div>
              </div>)}
          </div>

          <div className="max-w-md mx-auto" data-id="element-34">
            <CTAButton text="👉 QUIERO MI MEGAPACK CON LOS BONOS" size="sm" data-id="element-35" />
          </div>
        </div>
      </div>
    </section>;
}